// extracted by mini-css-extract-plugin
export default {"wrapper":"GA-z","viewport":"HA-z","container":"IA-z","slide":"JA-z"};